import {
  ReferenceInput,
  TextInput,
} from 'react-admin'
import { useLabel, useAddressInputFields } from '../../hooks'
import { Autocomplete } from '../custom'
import {
  referenceInputOptions,
  formInputOptions,
} from '../util/component-options'
import { getValidator } from '../form'

const AddressInputFields = ({ prefix = 'address', resource, addressRequired = true }) => {
  const label = useLabel({ resource })
  const addressFields = useAddressInputFields(prefix)

  return (
    addressFields.map(({ source, required, label: _label, reference, filter, disabled }) => (
      reference ?
        <ReferenceInput
          {...referenceInputOptions(reference)}
          {...formInputOptions}
          key={source}
          label={label(_label)}
          source={source}
          reference={reference}
          validate={getValidator(addressRequired && required)}
          required={addressRequired && required}
          perPage={1000}
          filter={{
            ...referenceInputOptions(reference).filter,
            ...filter,
          }}
          disabled={disabled}
        >
          <Autocomplete/>
        </ReferenceInput> :

        <TextInput
          {...formInputOptions}
          key={source}
          validate={getValidator(addressRequired && required)}
          source={source}
          autoComplete='chrome-off'
          label={label(_label)}
          required={addressRequired && required}
        />
    ))
  )
}

export default AddressInputFields
